import React from 'react';

import serverApi from '../../utils/serverApi';

/**
 * A higher order component wrapper that handles getting data on all the video pages.
 *
 * @param {Object} WrappedComponent
 * @returns {Object}
 */
export default function videoPagesHocWrapper(WrappedComponent) {
  /**
   * The video pages higher ticket component.
   */
  class VideoPagesHoc extends React.Component {
    /**
     * @constructor
     * @param {{}} props
     * @param {{}} componentContext
     */
    constructor(props, componentContext) {
      console.log('the video page hoc has been called');
      super(props, componentContext);

      this.state = {
        isLoading: false,
        videoPageData: null,
        videos:null,
        error: null,
      };
    }

    /**
     * Gets the video page type.
     */
    getVideoData = (pageSlug) => {
      this.setState({
        isLoading: true,
        videoPageData: null,
        videos:null,
        error: null,
      }, () => {
        serverApi.getVideoPages(pageSlug).then((response) => {
          this.setState({
            videoPageData: response,
            error:null
          });
          
        }, (error) => {
          
          this.setState({
            isLoading: false,
            videoPageData: null,
            error,
          });
        });
        serverApi.getVideos(pageSlug).then((response) => {
          this.setState({
            videos: response,
            isLoading: false,
            error:null
          });
         
        }, (error) => {
          this.setState({
            videos: null,
            isLoading: false,
            error,
          });
        });
      });
    };

    /**
     * Maps the Axios response to the data.
     *
     * @param {Array.<{id: number, name: string, abbreviation: string}>} data
     * @returns {Array.<{id: number, name: string, abbreviation: string}>}
     */
    mapResponse = (data) => {
      if (!data || !Array.isArray(data) || !data.length) {
        return [];
      }

      // Sort alphabetically by state name.
      data.sort((a, b) => {
        const nameA = a.name.toUpperCase();
        const nameB = b.name.toUpperCase();

        if (nameA < nameB) {
          return -1;
        } else if (nameA > nameB) {
          return 1;
        }
        return 0;
      });

      return data;
    };

    /**
     * Renders the WrappedComponent.
     *
     * @returns {Object}
     */
    render() {
      const newProps = {
        videoPagesHoc: {
          getVideoData: this.getVideoData,
          isLoading: this.state.isLoading || false,
          videoPageData: this.state.videoPageData,
          videos:this.state.videos,
          error: this.state.error
        }
      };

      return <WrappedComponent {...this.props} {...newProps} />
    }
  }

  VideoPagesHoc.propTypes = {};

  return VideoPagesHoc;
}



// WEBPACK FOOTER //
// ./src/components/hoc/videoPagesHoc.js